module.exports = window["popupMaker"]["icons"];